import { render, staticRenderFns } from "./diagnosisResultDetail.vue?vue&type=template&id=2e7283da&scoped=true"
import script from "./diagnosisResultDetail.vue?vue&type=script&lang=js"
export * from "./diagnosisResultDetail.vue?vue&type=script&lang=js"
import style0 from "./diagnosisResultDetail.vue?vue&type=style&index=0&id=2e7283da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7283da",
  null
  
)

export default component.exports